import React, { useEffect, useRef } from "react";
import "./ProductDetail133.css";

function ProductDetail133() {
  const secRef = useRef(null);

  useEffect(() => {
    const el = secRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("fcta--visible");
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="fcta-section" ref={secRef}>
      {/* Background */}
      <div className="fcta-bg" />
      <div className="fcta-glow fcta-glow--1" />
      <div className="fcta-glow fcta-glow--2" />
      <div className="fcta-grid-lines" />

      <div className="fcta-container">

        {/* Top accent bar */}
        <div className="fcta-accent-bar" />

        {/* Heading */}
        <h2 className="fcta-heading">
          Ready to Upgrade Your
          <br />
          <span>Toll Infrastructure?</span>
        </h2>

        {/* Description */}
        <p className="fcta-desc">
          Experience the future of toll monitoring with TPMS. Improve
          efficiency, eliminate fraud, and gain complete control over
          your toll operations. Book a free demo today.
        </p>

        {/* Trust chips */}
        <div className="fcta-chips">
          <div className="fcta-chip">
            <i className="bi bi-calendar2-check-fill" />
            Free Demo Available
          </div>
          <div className="fcta-chip">
            <i className="bi bi-patch-check-fill" />
            NHAI Compliant
          </div>
          <div className="fcta-chip">
            <i className="bi bi-headset" />
            24/7 Support
          </div>
        </div>

        {/* Buttons */}
        <div className="fcta-buttons">
          <a href="/contact-us" className="fcta-btn demo-btn ">
            <i className="bi bi-calendar2-check-fill" />
            Book Free Demo
          </a>
          <a href="/contact-us" className="fcta-btn demo-btn">
            <i className="bi bi-telephone-fill" />
            Talk to Expert
          </a>
        </div>

        {/* Bottom note */}
        <p className="fcta-note">
          <i className="bi bi-lock-fill" />
          Your data is secure and encrypted. No spam, ever.
        </p>

      </div>
    </section>
  );
}

export default ProductDetail133;